import { Component, Prop, Host, h, State, Fragment } from '@stencil/core';

import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'

// function navigation (slider) {
//   let wrapper, dots, arrowLeft, arrowRight,timeout
//   let mouseOver = false

//   function clearNextTimeout() {
//     clearTimeout(timeout)
//   }
//   function nextTimeout() {
//     clearTimeout(timeout)
//     if (mouseOver) return
//     timeout = setTimeout(() => {
//       slider.next()
//     }, 3000)
//   }


//   function markup(remove?) {
//     wrapperMarkup(remove)
//     dotMarkup(remove)
//     arrowMarkup(remove)
//   }

//   function removeElement(elment) {
//     elment.parentNode.removeChild(elment)
//   }
//   function createDiv(className) {
//     var div = document.createElement("div")
//     var classNames = className.split(" ")
//     classNames.forEach((name) => div.classList.add(name))
//     return div
//   }

//   function arrowMarkup(remove) {
//     if (remove) {
//       removeElement(arrowLeft)
//       removeElement(arrowRight)
//       return
//     }
//     arrowLeft = createDiv("arrow arrow--left sc-slider-component")
//     arrowLeft.addEventListener("click", () => slider.prev())
//     arrowRight = createDiv("arrow arrow--right sc-slider-component")
//     arrowRight.addEventListener("click", () => slider.next())

//     wrapper.appendChild(arrowLeft)
//     wrapper.appendChild(arrowRight)
//   }

//   function wrapperMarkup(remove) {
//     if (remove) {
//       var parent = wrapper.parentNode
//       while (wrapper.firstChild)
//         parent.insertBefore(wrapper.firstChild, wrapper)
//       removeElement(wrapper)
//       return
//     }
//     wrapper = createDiv("navigation-wrapper sc-slider-component")
//     slider.container.parentNode.appendChild(wrapper)
//     wrapper.appendChild(slider.container)
//   }

//   function dotMarkup(remove) {
//     if (remove) {
//       removeElement(dots)
//       return
//     }
//     dots = createDiv("dots sc-slider-component")
//     slider.track.details.slides.forEach((_e, idx) => {
//       var dot = createDiv("dot sc-slider-component")
//       dot.addEventListener("click", () => slider.moveToIdx(idx))
//       dot.classList.add("sc-slider-component")
//       dots.appendChild(dot)
//     })
//     wrapper.appendChild(dots)
//   }

//   function updateClasses() {
//     var slide = slider.track.details.rel
//     slide === 0
//       ? arrowLeft.classList.add("arrow--disabled")
//       : arrowLeft.classList.remove("arrow--disabled")
//     slide === slider.track.details.slides.length - 1
//       ? arrowRight.classList.add("arrow--disabled")
//       : arrowRight.classList.remove("arrow--disabled")
//     Array.from(dots.children).forEach(function (dot:any, idx) {
//       idx === slide
//         ? dot.classList.add("dot--active","sc-slider-component")
//         : dot.classList.remove("dot--active")
//     })
//   }

//   slider.on("created", () => {
//     markup()
//     updateClasses()
//     slider.container.addEventListener("mouseover", () => {
//       mouseOver = true
//       clearNextTimeout()
//     })
//     slider.container.addEventListener("mouseout", () => {
//       mouseOver = false
//       nextTimeout()
//     })
//     nextTimeout()
//   })
//   slider.on("optionsChanged", () => {
//     console.log(2)
//     markup(true)
//     markup()
//     updateClasses()
//   })
//   slider.on("slideChanged", () => {
//     updateClasses()
//   })
//   slider.on("destroyed", () => {
//     markup(true)
//   })
//   slider.on("dragStarted", clearNextTimeout)
//   slider.on("animationEnded", nextTimeout)
//   slider.on("updated", nextTimeout)
// }
@Component({
  tag: 'slider-component',
  styleUrl: 'slider-component.css',
  // shadow: true,
  scoped: true
})
export class SliderComponent {


  /**
   *Required - Unique ID.
   */
   @Prop() componentid: string = "comp-id";

   /**
   *Required - List Name.
   */
   @Prop() listname: string = "ListName";
 
   /**
   *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
   */
   @Prop() webpath: string = "/";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() sectiontitle: string = "Section Title";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() titleiconurl: string = "";
 
   /**
  *Optional - To show/hide header. default is true
  */
   @Prop() header: boolean = true;
 
   /**
  *Optional - vertical scroll bar
  */
   @Prop() verticalscroll: boolean = false;
 
   /**
  *Optional - vertical scroll bar height
  */
   @Prop() verticalscrollheight: number = 200;
 
   /**
  *Optional - To show see All link
  */
   @Prop() seeall: boolean = false;
   /**
  *Optional - see All Url
  */
   @Prop() seeallurl: string;
 
   /**
 *Optional - see All link Title
 */
   @Prop() seealltitle: string = "See All";
 
   /**
     *Optional - number of items to retrieve
     */
   @Prop() count: number = 100;
 
   /**
 *Optional - header background color
 */
   @Prop() headerbgcolor: string = "white"
 
   /**
   *Optional -header text color
   */
   @Prop() headertextcolor: string = "black"
   /**
   *Optional -header border bottom css
   */
   @Prop() headerborderbottom: string = "1px solid #CE2127"
 
 
   /**
   *Optional - headertext location
 */
   @Prop() headerlocation: string = "top";
 
 
 
 
 
   /**
 *Optional - is it SP Online site
 */
   @Prop() online: boolean = false;
 
   /**
    *Required - site url if its sp online site
    */
   @Prop() siteurl: string = "";
 
   @State() items: []= []
   @State() isLoading: boolean = false
 

   navigation =(slider)  =>{
    let wrapper, dots, arrowLeft, arrowRight,timeout
    let mouseOver = false
  
    function clearNextTimeout() {
      clearTimeout(timeout)
    }
    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next()
      }, 3000)
    }
  
  
    function markup(remove?) {
      wrapperMarkup(remove)
      dotMarkup(remove)
      arrowMarkup(remove)
    }
  
    function removeElement(elment) {
      elment.parentNode.removeChild(elment)
    }
    function createDiv(className) {
      var div = document.createElement("div")
      var classNames = className.split(" ")
      classNames.forEach((name) => div.classList.add(name))
      return div
    }
  
    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft)
        removeElement(arrowRight)
        return
      }
      arrowLeft = createDiv("arrow arrow--left sc-slider-component")
      arrowLeft.addEventListener("click", () => slider.prev())
      arrowRight = createDiv("arrow arrow--right sc-slider-component")
      arrowRight.addEventListener("click", () => slider.next())
  
      wrapper.appendChild(arrowLeft)
      wrapper.appendChild(arrowRight)
    }
  
    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper)
        removeElement(wrapper)
        return
      }
      wrapper = createDiv("navigation-wrapper sc-slider-component")
      slider.container.parentNode.appendChild(wrapper)
      wrapper.appendChild(slider.container)
    }
  
    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots)
        return
      }
      dots = createDiv("dots sc-slider-component")
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createDiv("dot sc-slider-component")
        dot.addEventListener("click", () => slider.moveToIdx(idx))
        dot.classList.add("sc-slider-component")
        dots.appendChild(dot)
      })
      wrapper.appendChild(dots)
    }
  
    function updateClasses() {
      var slide = slider.track.details.rel
      slide === 0
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled")
      slide === slider.track.details.slides.length - 1
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled")
      Array.from(dots.children).forEach(function (dot:any, idx) {
        idx === slide
          ? dot.classList.add("dot--active","sc-slider-component")
          : dot.classList.remove("dot--active")
      })
    }
  
    slider.on("created", () => {
      markup()
      updateClasses()
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false
        nextTimeout()
      })
      nextTimeout()
    })
    slider.on("optionsChanged", () => {
      console.log(2)
      markup(true)
      markup()
      updateClasses()
    })
    slider.on("slideChanged", () => {
      updateClasses()
    })
    slider.on("destroyed", () => {
      markup(true)
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
  }


  componentDidRender() {

    var slider = new KeenSlider("#" + this.componentid+'-' + 'slider', {loop: true}
      , [this.navigation])
  }

 getContents = (sliderid:string)=> {

const resultArray =[]

resultArray.push (
  <div id={sliderid} class="keen-slider">
  <div class="keen-slider__slide ">
    <img class="img-fluid rounded mx-auto d-block"
      src="https://infonet.nyp.org/ai/Lists/Announcements/EditForm/AANHPI%20Logo%20Infonet.png" />
  </div>
  <div class="keen-slider__slide ">
    <img class="img-fluid rounded mx-auto d-block"
      src="https://infonet.nyp.org/ai/Lists/Announcements/NewForm/leadership%20video-5-1-2023_B.jpg" />
  </div>
  <div class="keen-slider__slide ">
    <img class="img-fluid rounded mx-auto d-block"
      src="https://infonet.nyp.org/ai/Lists/Announcements/NewForm/PX-QualitySafetyExperience_InfonetGraphic.jpg" />
  </div>
  <div class="keen-slider__slide ">
    <img class="img-fluid rounded mx-auto d-block"
      src="https://infonet.nyp.org/ai/Lists/Announcements/NewForm/MaskUpdateIMG_0885.jpg" />
  </div>
  </div>

)



return resultArray
 }

 


  render() {

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"

      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }

    let sliderid = this.componentid + '-' + 'slider'

    return (

      this.isLoading ? <loader-component /> :

        this.header && this.items.length > 0 ?
          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle}>
              <div style={styleWithHeader}>
              
                {this.getContents(sliderid)}
                </div>

          
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle}>
            <div style={style}>
             
              {this.getContents(sliderid)}
          

            </div>
          </div>




      
    );
  }

}
